import { render, staticRenderFns } from "./ConsolidationUnionCreate.vue?vue&type=template&id=040bddbc&scoped=true"
import script from "./ConsolidationUnionCreate.vue?vue&type=script&lang=js"
export * from "./ConsolidationUnionCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040bddbc",
  null
  
)

export default component.exports